import { useEffect, useRef, useState, useCallback } from 'react'
import { dashboardApi } from '../services/api'
import { getSocket } from '../services/socket'

const POLL_MS = 300_000
const SOCKET_DEBOUNCE_MS = 30_000

// TODO: type this
// eslint-disable-next-line @typescript-eslint/no-explicit-any
type HomeSnapshot = any

export function useDashboardHome() {
  const [data, setData] = useState<HomeSnapshot>(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<unknown>(null)
  const timer = useRef<ReturnType<typeof setInterval>>()
  const lastSocketRefetch = useRef(0)

  const refresh = useCallback(async (force?: boolean) => {
    try { setData(await dashboardApi.home(force)); setError(null) }
    catch (e) { setError(e) }
    finally { setLoading(false) }
  }, [])

  useEffect(() => {
    refresh()
    timer.current = setInterval(() => { if (!document.hidden) refresh() }, POLL_MS)

    const socket = getSocket()
    const nudge = () => {
      const now = Date.now()
      if (now - lastSocketRefetch.current < SOCKET_DEBOUNCE_MS) return
      lastSocketRefetch.current = now
      if (!document.hidden) refresh()
    }
    socket?.on('notification:updated', nudge)
    socket?.on('message:mention', nudge)
    return () => {
      clearInterval(timer.current)
      socket?.off('notification:updated', nudge)
      socket?.off('message:mention', nudge)
    }
  }, [refresh])

  return { data, loading, error, refresh }
}
